/** @format */

import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import { CardWrapper } from "./styles";
import SkeletonTotalCircle from "./SkeletonTotalCircle";
import { colors } from "../../../utility/types/constant";
interface TotalCircleProps {
	isLoading: boolean;
	activeCircles: number;
}

const TotalCircleCard = (props: TotalCircleProps) => {
	const { isLoading, activeCircles } = props;

	const theme = useTheme();

	return (
		<div>
			{isLoading ? (
				<SkeletonTotalCircle />
			) : (
				<CardWrapper border={false} content={false}>
					<Box sx={{ p: 1.5 }}>
						<Grid container direction="column">
							<Grid item>
								<Grid container justifyContent="space-between">
									<Grid item>
										<Avatar
											variant="rounded"
											sx={{
												...theme.typography,
												...theme.typography,
												backgroundColor: theme.palette.primary as any[800],
												color: "#fff",
												mt: 1,
											}}>
											<img
												style={{ backgroundColor: "#ffffff" }}
												src="/assets/icons/group-icon.png"
												alt="earning icon"
											/>
										</Avatar>
									</Grid>
								</Grid>
							</Grid>
							<Grid item sx={{ mb: 0.75 }}>
								<Grid
									container
									alignItems="center"
									justifyContent="center"
									textAlign="center">
									<Grid item xs={6}>
										<Grid container alignItems="center">
											<Grid item>
												<Typography
													sx={{
														fontSize: "2.125rem",
														fontWeight: 500,
														mr: 1,
														color: colors.white,
													}}>
													{activeCircles}
												</Typography>
											</Grid>

											{/* <Grid item>
                        <Avatar
                          sx={{
                            ...theme.typography,
                            cursor: "pointer",
                            backgroundColor: colors.white,
                            color: theme.palette.primary.dark,
                          }}
                        >
                          <ArrowOutwardIcon
                            fontSize="inherit"
                            sx={{ transform: "rotate3d(1, 1, 1, 45deg)" }}
                          />
                        </Avatar>
                      </Grid> */}

											<Grid item xs={12}>
												<Typography
													sx={{
														fontSize: "1.5rem",
														fontWeight: 900,
														fontFamily: "'Montserrat', sans-serif",
														color: colors.white,
														mt: 1,
													}}>
													Total Circle
												</Typography>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Box>
				</CardWrapper>
			)}
		</div>
	);
};

TotalCircleCard.propTypes = {
	isLoading: PropTypes.bool,
	activeCircles: PropTypes.number,
};

export default TotalCircleCard;
